export const INIT_DATA_RECORDED = {
  isOpen: false,
  data: [],
  title: '',
};

export const INIT_DATA_ACCESS_CODE = {
  open: false,
  eventId: '',
};

export const INIT_DATA = {
  data: [],
  currentPage: 1,
  totalPage: 0,
  totalItems: 0,
};

export const TIMEZONE_DEFAULT = 'Asia/Singapore';
